import { Icon } from '@iconify/react'

import { Button } from 'common/components/Button/Button'
import { BUTTON_MODIFIER, BUTTON_PROPORTION } from 'common/constants/buttonConstants'

import styles from './confirm-mark-billed-view.module.scss'

type Props = {
  onCancel: () => void
  onConfirm: () => void
  isSubmitting: boolean
}

const TITLE = 'No Payment to Process'
const MESSAGE =
  'There is no payment amount, credit, or discount to post. Would you like to mark this encounter as Billed?'

export const ConfirmMarkBilledView = ({ onCancel, onConfirm, isSubmitting }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <Icon icon='mdi:alert-circle-outline' width={48} height={48} />
      </div>
      <div className={styles.textGroup}>
        <h3 className={styles.title}>{TITLE}</h3>
        <p className={styles.subtitle}>{MESSAGE}</p>
      </div>
      <div className={styles.footer}>
        <Button
          modifier={BUTTON_MODIFIER.SECONDARY}
          proportion={BUTTON_PROPORTION.LARGE}
          onClick={onCancel}
          disabled={isSubmitting}
          className={styles.cancelButton}>
          Cancel
        </Button>
        <Button
          proportion={BUTTON_PROPORTION.LARGE}
          onClick={onConfirm}
          disabled={isSubmitting}
          loading={isSubmitting}
          className={styles.confirmButton}>
          Mark as Billed
        </Button>
      </div>
    </div>
  )
}
